/* Progressive enhancement only: native details and links also work without JS. */
(() => {
  if (window.bmeMenuInitialized) return;
  window.bmeMenuInitialized = true;
  function revealHash(hash, scroll) {
    if (!hash || hash === '#') return;
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch (_) { return; }
    const target = document.getElementById(id);
    if (!target) return;
    let parent = target.closest('details');
    while (parent) { parent.open = true; parent = parent.parentElement?.closest('details'); }
    const chapter = target.querySelector('details.bme-chapter');
    if (chapter) chapter.open = true;
    if (scroll) requestAnimationFrame(() => target.scrollIntoView({block: 'start', behavior: 'auto'}));
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && url.pathname === location.pathname && url.hash) revealHash(url.hash, true);
  });
  window.addEventListener('hashchange', () => revealHash(location.hash, true));
  document.addEventListener('shopify:block:select', event => { const parent = event.target.closest('details'); if (parent) parent.open = true; });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => revealHash(location.hash, true), {once: true});
  else revealHash(location.hash, true);
})();
